var map = {
	"./add-math.svg": "./src/assets/images/add-math.svg",
	"./add_image.svg": "./src/assets/images/add_image.svg",
	"./analytics.svg": "./src/assets/images/analytics.svg",
	"./analyze.svg": "./src/assets/images/analyze.svg",
	"./check-circle-regular.svg": "./src/assets/images/check-circle-regular.svg",
	"./check-square-regular.svg": "./src/assets/images/check-square-regular.svg",
	"./check.svg": "./src/assets/images/check.svg",
	"./chevron-down-solid-white.svg": "./src/assets/images/chevron-down-solid-white.svg",
	"./chevron-down-solid.svg": "./src/assets/images/chevron-down-solid.svg",
	"./chevron-left-solid.svg": "./src/assets/images/chevron-left-solid.svg",
	"./chevron-right-solid.svg": "./src/assets/images/chevron-right-solid.svg",
	"./chevron-up-solid.svg": "./src/assets/images/chevron-up-solid.svg",
	"./chrome.svg": "./src/assets/images/chrome.svg",
	"./code-braces.svg": "./src/assets/images/code-braces.svg",
	"./copy.svg": "./src/assets/images/copy.svg",
	"./create.svg": "./src/assets/images/create.svg",
	"./delete.svg": "./src/assets/images/delete.svg",
	"./delete2.svg": "./src/assets/images/delete2.svg",
	"./docs.svg": "./src/assets/images/docs.svg",
	"./download.svg": "./src/assets/images/download.svg",
	"./edit.svg": "./src/assets/images/edit.svg",
	"./enter-fullscreen.svg": "./src/assets/images/enter-fullscreen.svg",
	"./exclamation-circle-solid.svg": "./src/assets/images/exclamation-circle-solid.svg",
	"./exit-fullscreen.svg": "./src/assets/images/exit-fullscreen.svg",
	"./gift.svg": "./src/assets/images/gift.svg",
	"./google.svg": "./src/assets/images/google.svg",
	"./google_form.svg": "./src/assets/images/google_form.svg",
	"./hand-point-left-solid.svg": "./src/assets/images/hand-point-left-solid.svg",
	"./home-rounded.svg": "./src/assets/images/home-rounded.svg",
	"./home.svg": "./src/assets/images/home.svg",
	"./image-regular.svg": "./src/assets/images/image-regular.svg",
	"./interaction.svg": "./src/assets/images/interaction.svg",
	"./left.svg": "./src/assets/images/left.svg",
	"./link.svg": "./src/assets/images/link.svg",
	"./lock.svg": "./src/assets/images/lock.svg",
	"./logout.svg": "./src/assets/images/logout.svg",
	"./menu.svg": "./src/assets/images/menu.svg",
	"./move.svg": "./src/assets/images/move.svg",
	"./phone-alt-solid.svg": "./src/assets/images/phone-alt-solid.svg",
	"./play.svg": "./src/assets/images/play.svg",
	"./plus-solid.svg": "./src/assets/images/plus-solid.svg",
	"./publish.svg": "./src/assets/images/publish.svg",
	"./question-circle-regular.svg": "./src/assets/images/question-circle-regular.svg",
	"./radio-button.svg": "./src/assets/images/radio-button.svg",
	"./search-solid.svg": "./src/assets/images/search-solid.svg",
	"./settings.svg": "./src/assets/images/settings.svg",
	"./share.svg": "./src/assets/images/share.svg",
	"./skip.svg": "./src/assets/images/skip.svg",
	"./spinner-solid.svg": "./src/assets/images/spinner-solid.svg",
	"./spinner.svg": "./src/assets/images/spinner.svg",
	"./subjective-question.svg": "./src/assets/images/subjective-question.svg",
	"./teams.svg": "./src/assets/images/teams.svg",
	"./times-circle-solid.svg": "./src/assets/images/times-circle-solid.svg",
	"./times-circle-white.svg": "./src/assets/images/times-circle-white.svg",
	"./times-light.svg": "./src/assets/images/times-light.svg",
	"./times-solid.svg": "./src/assets/images/times-solid.svg",
	"./twitter.svg": "./src/assets/images/twitter.svg",
	"./video-thumbnail.svg": "./src/assets/images/video-thumbnail.svg",
	"./whatsapp-greyscale.svg": "./src/assets/images/whatsapp-greyscale.svg",
	"./whatsapp.svg": "./src/assets/images/whatsapp.svg",
	"./window-close-solid.svg": "./src/assets/images/window-close-solid.svg",
	"./youtube.svg": "./src/assets/images/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.svg$";